import { Breadcrumb, ConfigProvider, Typography } from 'antd';
import { useTitle } from 'contexts/TitleProvider';

const PageTitle = () => {
  const { Text } = Typography;
  const { title, itemsBreadcrumb } = useTitle();
  return (
    <>
      <Text className="text-[#003056] font-bold text-2xl">{title}</Text>
      <ConfigProvider
        theme={{
          components: {
            Breadcrumb: {
              lastItemColor: '#003056',
            },
          },
        }}
      >
        <Breadcrumb items={itemsBreadcrumb} />
      </ConfigProvider>
    </>
  );
};

export default PageTitle;
